import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { ThemeProvider } from "styled-components";

import MainHeading from "./Components/MainHeading";
import PickerGrid from "./Components/PickerGrid";
import { random } from "lodash";

const App = () => {
  const regProducts = reg;
  const minProducts = mini;

  const [selection, setSelection] = useState(
    editSelector
      ? editSelector.items.flatMap((item) => {
          let itemQty = item.quantity;
          if (itemQty === 1) {
            return item;
          } else {
            let r = [];
            const singleItem = { ...item, quantity: 1 };
            while (itemQty > 0) {
              r.push(singleItem);
              itemQty--;
            }
            return r;
          }
        })
      : [null, null, null, null, null, null],
  );

  const [isMini, setIsMini] = useState(
    editSelector && editSelector.range === "mini" ? true : false,
  );
  const [currentRange, setCurrentRange] = useState(
    editSelector && editSelector.range === "mini" ? minProducts : regProducts,
  );
  // * personalisation charge per message in pence
  const msgPrice = currentRange.bundle_name === "MINI_OBJ" ? 65 : 75;
  const [newRange, setNewRange] = useState("");
  const [limit, setLimit] = useState(currentRange.box_size.small);
  const [showMessages, setShowMessages] = useState(false);
  const [singleMessage, setSingleMessage] = useState(false);
  const [singleMessageContent, setSingleMessageContent] = useState("");
  const [rangeModalOpen, setRangeModalOpen] = useState(false);
  const [messages, setMessages] = useState([]);

  const [editable, setEditable] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [sWidth, setSWidth] = useState(0);

  const [expanded, setExpanded] = useState(null);
  const [presetMsg, setPresetMsg] = useState("");

  const [firstMsg, setFirstMsg] = useState(null);
  const [personalisationSelected, setPersonalisationSelected] = useState(
    editSelector && editSelector.items.find((item) => item.message)
      ? true
      : false,
  );

  useEffect(() => {
    const checkScreenWidth = () => {
      const width = window.innerWidth;
      setSWidth(width);
      if (width >= 1230) {
        if (isMobile) {
          editable ? setEditable(false) : null;
          setIsMobile(false);
          document.documentElement.style.overflowY = null;
          document.documentElement.style.touchAction = null;
        }
      } else {
        setIsMobile(true);
      }
    };
    checkScreenWidth();
    window.addEventListener("resize", checkScreenWidth);
    return () => {
      window.removeEventListener("resize", checkScreenWidth);
    };
  }, [sWidth]);

  const handleLimitChange = (e) => {
    let newLimit = parseInt(e.target.textContent);
    let newSelection = [...selection];
    if (newSelection.length < newLimit) {
      while (newSelection.length < newLimit) {
        newSelection.push(null);
      }
    } else if (newSelection.length > newLimit) {
      while (newSelection.length > newLimit) {
        newSelection.pop();
      }
    }
    setSelection(newSelection);
    setLimit(newLimit);
  };

  const buildBId = () => {
    return Math.floor(1000 * Math.random() * 9000);
  };
  const handleAddItem = (
    title,
    frontendTitle,
    productID,
    variantID,
    limitedAvailability,
    price,
    img,
    personalisation,
    characterLimit,
    isRandom,
  ) => {
    setSelection((selection) => {
      let newSelection = [...selection];
      let slot = newSelection.indexOf(null);

      newSelection[slot] = {
        title: title,
        frontend_title: frontendTitle,
        id: variantID,
        productID: productID,
        ...(limitedAvailability?.length
          ? { limitedAvailability: limitedAvailability }
          : {}),
        bId: buildBId(),
        price:
          (singleMessageContent.length || presetMsg) && personalisation === "Y"
            ? parseInt(price) + msgPrice
            : price,
        quantity: 1,
        img: img,
        personalisation_available: personalisation,
        random: isRandom,
        char_count: characterLimit,
        message:
          singleMessageContent.length && personalisation === "Y"
            ? singleMessageContent
            : presetMsg.length && personalisation === "Y"
            ? presetMsg
            : null,
      };

      !newSelection.filter((item) => item === null).length
        ? setExpanded(true)
        : null;
      setSelection(newSelection);
      return newSelection;
    });
  };

  const disableMessage = (id, status) => {
    if (messages.length) {
      messages.forEach((msg) => {
        if (msg.id === id && status === "n") {
          setMessages((messages) => {
            let newMsgs = [...messages].splice(id, 1);
            return newMsgs;
          });
        } else if (msg.id === id && status === "y") {
          `input with id ${id} is ENABLED`;
        }
      });
    }
  };

  const handleAddMessage = (content, id) => {
    let isValidMsg = validateMsg(content);
    if (isValidMsg) {
      setSelection((selection) => {
        let n = [...selection];
        let t = n.map((selectionItem) => {
          if (
            selectionItem !== null &&
            selectionItem.bId === id &&
            content !== ""
          ) {
            if (!selectionItem.message) {
              return {
                ...selectionItem,
                message: content,
                price: parseInt(selectionItem.price) + msgPrice,
              };
            } else {
              return { ...selectionItem, message: content };
            }
          } else if (
            selectionItem !== null &&
            selectionItem.bId === id &&
            selectionItem.message &&
            content === ""
          ) {
            return {
              ...selectionItem,
              message: "",
              price: parseInt(selectionItem.price) - msgPrice,
            };
          }
          return selectionItem;
        });
        return t;
      });
    } else {
      return;
    }
  };

  const validateMsg = (msg) => {
    let cLim = currentRange.personalisation.max_characters;
    let mArr = msg.split("");
    let cCount = 0;
    for (let y of mArr) {
      if (y.toLowerCase() === y) {
        cCount++;
      } else if (y.toLowerCase() !== y || y === " ") {
        cCount += 2;
      }
    }
    return cCount <= cLim ? true : false;
  };

  const updateItemRemove = (id) => {
    setSelection((selection) => {
      let newSelection = [...selection];
      if (id.toString().length < 3) {
        newSelection.splice(id, 1, null);
      } else {
        let y = [];
        newSelection.forEach((x, i) => {
          x === null
            ? null
            : x.id === id || x.variantID === id
            ? y.push(i)
            : null;
        });
        newSelection.splice(y[y.length - 1], 1, null);
      }

      newSelection.filter((item) => item !== null).length
        ? null
        : setEditable(false);

      return newSelection;
    });
  };

  const clearSelection = () => {
    setSelection((selection) => {
      let newSelection = [...selection];
      newSelection.forEach((item) => {
        if (item !== null) {
          newSelection.splice(newSelection.indexOf(item), 1, null);
        }
      });
      return newSelection;
    });
    setShowMessages(false);
    setSingleMessage(false);
    setSingleMessageContent("");
  };

  const handleRangeSwitch = () => {
    //let t = e.target.id;
    let newRange = isMini ? regProducts : minProducts;

    // for toggle
    setIsMini(!isMini);

    let x = selection.filter((y) => y !== null);

    if (x.length) {
      if (currentRange === newRange) {
        return;
      } else {
        setNewRange(newRange);
        setRangeModalOpen(!rangeModalOpen);
      }
    } else if (currentRange !== newRange && !x.length) {
      setCurrentRange(newRange);
      let isMini = newRange.bundle_name === "MINI_OBJ" ? true : false;
      let nLimit;
      if (isMini) {
        nLimit =
          limit === 6
            ? (nLimit = newRange.box_size.small)
            : newRange.box_size.large;
      } else {
        nLimit =
          limit === 12
            ? (nLimit = newRange.box_size.small)
            : newRange.box_size.large;
      }
      setLimit(nLimit);
      setSelection((selection) => {
        let newSelection = [...selection];
        if (newSelection.length < nLimit) {
          while (newSelection.length < nLimit) {
            newSelection.push(null);
          }
        } else if (newSelection.length > nLimit) {
          while (newSelection.length > nLimit) {
            newSelection.pop();
          }
        }
        return newSelection;
      });
    }

    return;
  };

  const randomise = () => {
    let newSelection = selection;
    let randomSelection = [];
    let products = currentRange.products;
    let emptySlots = newSelection.filter(
      (x) => x === null || x.random === true,
    );

    let t;

    if (emptySlots.length) {
      emptySlots.forEach(() => {
        let rng = Math.floor(Math.random() * products.length);
        // ! getting the whole product obj leaves variantID as id, adjust to reduce complexity
        randomSelection.push(products[rng]);
      });
      let count = 0;

      t = newSelection.map((selectionItem) => {
        if (selectionItem === null || selectionItem.random === true) {
          let rProduct;
          if (selectionItem === null) {
            rProduct = {
              ...randomSelection[count],
              quantity: 1,
              ...(randomSelection[count].personalisation_available === "Y"
                ? { message: presetMsg ? presetMsg : null }
                : {}),
              random: true,
              bId: buildBId(),
            };
          } else {
            if (
              (selectionItem.message || presetMsg) &&
              randomSelection[count].personalisation_available === "Y"
            ) {
              rProduct = {
                ...randomSelection[count],
                message: selectionItem.message || presetMsg,
                price: selectionItem.price,
                quantity: 1,
                random: true,
                bId: buildBId(),
              };
            } else {
              rProduct = {
                ...randomSelection[count],
                quantity: 1,
                random: true,
                bId: buildBId(),
              };
            }
          }
          count++;
          return rProduct;
        } else if (selectionItem !== null && selectionItem.random === false) {
          return selectionItem;
        }
      });
    } else if (!emptySlots.length) {
      selection.forEach(() => {
        let rng = Math.floor(Math.random() * products.length);
        randomSelection.push(products[rng]);
      });
      t = newSelection.map((selectionItem, i) => {
        if (
          selectionItem.message &&
          randomSelection[i].personalisation_available === "Y"
        ) {
          return {
            ...randomSelection[i],
            message: selectionItem.message,
            price: selectionItem.price,
            quantity: 1,
            random: true,
          };
        } else {
          return { ...randomSelection[i], quantity: 1, random: true };
        }
      });
    }
    setSelection(t);
  };

  const handleShowMessages = () => {
    if (showMessages === true) {
      setSelection((selection) => {
        let x = [...selection];
        let y = x.map((item) => {
          if (item !== null && item.message) {
            return { ...item, message: "", price: item.price - msgPrice };
          }
          return item;
        });
        return y;
      });
    }
    setShowMessages(!showMessages);
  };

  const handleSingleMessage = (singleMessage) => {
    let isValid = validateMsg(singleMessage);
    if (isValid) {
      setSingleMessageContent(singleMessage);
      setSelection((selection) => {
        let x = [...selection];
        let y = x.map((item) => {
          if (item !== null && singleMessage !== "") {
            if (item.message && item.personalisation_available === "Y") {
              return { ...item, message: singleMessage };
            } else if (
              !item.message &&
              item.personalisation_available === "Y"
            ) {
              return {
                ...item,
                message: singleMessage,
                price: parseInt(item.price) + msgPrice,
              };
            }
          } else if (
            item !== null &&
            singleMessage === "" &&
            item.personalisation_available === "Y"
          ) {
            return { ...item, message: "", price: parseInt(item.price) - msgPrice };
          }
          return item;
        });
        return y;
      });
    } else {
      return;
    }
  };

  const clearMultiMessage = () => {
    setSelection((selection) => {
      let x = [...selection];
      let y = x.map((item) => {
        if (item !== null && item.message) {
          return { ...item, price: parseInt(item.price) - msgPrice, message: "" };
        }
        return item;
      });
      return y;
    });
    setPresetMsg("");
  };

  return (
    <>
      <PickerGrid
        products={currentRange}
        limit={limit}
        selection={selection}
        handleLimitChange={handleLimitChange}
        handleRangeSwitch={handleRangeSwitch}
        handleAddItem={handleAddItem}
        clearSelection={clearSelection}
        updateItemRemove={updateItemRemove}
        randomise={randomise}
        showMessages={showMessages}
        setShowMessages={setShowMessages}
        rangeName={currentRange.bundle_name}
        singleMessage={singleMessage}
        setSingleMessage={setSingleMessage}
        handleAddMessage={handleAddMessage}
        messages={messages}
        disableMessage={disableMessage}
        handleShowMessages={handleShowMessages}
        handleSingleMessage={handleSingleMessage}
        clearMultiMessage={clearMultiMessage}
        singleMessageContent={singleMessageContent}
        rangeModalOpen={rangeModalOpen}
        setRangeModalOpen={setRangeModalOpen}
        regP={regProducts}
        miniP={minProducts}
        setNewRange={setNewRange}
        newRange={newRange}
        setCurrentRange={setCurrentRange}
        setLimit={setLimit}
        setSelection={setSelection}
        isMobile={isMobile}
        editable={editable}
        setEditable={setEditable}
        personalisationSelected={personalisationSelected}
        setPersonalisationSelected={setPersonalisationSelected}
        expanded={expanded}
        setExpanded={setExpanded}
        isMini={isMini}
        setIsMini={setIsMini}
        firstMsg={firstMsg}
        setFirstMsg={setFirstMsg}
        presetMsg={presetMsg}
        setPresetMsg={setPresetMsg}
        buildBId={buildBId}
      />
    </>
  );
};

export default App;
